import { LabelsDropdownComponent, MenuAction } from '@anecdotes/design-system/dropdown-menu';
import { TrustCenterFacadeService } from '@anecdotes/shared-trust-center';
import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { SlackUserChannel } from '../../models/slack-user-channel.model';
import { AlertService } from '@anecdotes/design-system/alert';

@Component({
  selector: 'app-slack-channels-users-dropdown',
  templateUrl: './slack-channels-users-dropdown.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SlackChannelsUsersDropdownComponent implements OnChanges {
  @HostBinding('class')
  private readonly classes = 'inline';

  @ViewChild('labelsDropdown')
  private labelsDropdown: LabelsDropdownComponent;

  @Input()
  channelsUsersData: SlackUserChannel[];

  @Input()
  selectedDataIds: string[];

  @Input()
  selectedInstanceId: string;

  selectedData: SlackUserChannel[];
  readonly bottomDropdownAction: MenuAction = {
    displayCondition: () => !!this.selectedData?.length,
    translationKey: this.buildTranslationKey('clearAll'),
    classStyle: 'border-t border-navy-30',
    icon: 'clear-form',
    action: () => {
      this.labelsDropdown.close();
      this.editChannels([]);
    },
  };

  constructor(
    private trustCenterFacadeService: TrustCenterFacadeService,
    private alertService: AlertService,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.channelsUsersData || changes.selectedDataIds) {
      this.selectedData = this.channelsUsersData?.filter((channel) => this.selectedDataIds?.includes(channel.id));
    }
  }

  buildTranslationKey(key: string): string {
    return `trustCenter.${key}`;
  }

  async editChannels(selected: SlackUserChannel[]): Promise<void> {
    const selectedIds = selected.map((selectedItem) => selectedItem.id);
    if (this.isSelectedDataUnchanged(selectedIds)) {
      return;
    }

    try {
      await this.trustCenterFacadeService.updateSettings({
        slack_account: this.selectedInstanceId,
        slack_recipients: selectedIds,
      });
    } catch {
      this.alertService.openActionErrorAlert({
        customBaseTranslationKey: this.buildTranslationKey('errorSlack'),
      });
    }
  }

  displayChannelValueSelector(item: SlackUserChannel): string {
    return item.name;
  }

  channelIdSelector(item: SlackUserChannel): string {
    return item.id;
  }

  private isSelectedDataUnchanged(selectedIds: string[]): boolean {
    return (
      this.selectedDataIds?.length === selectedIds.length &&
      this.selectedDataIds?.every((id: string) => selectedIds.includes(id))
    );
  }
}
